import React from 'react';
import { RotateCcw, Package, Clock, AlertCircle } from 'lucide-react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useApp } from '../../context/AppContext';

const RuilenRetournerenPage = () => {
  const { t } = useApp();
  
  return (
    <div className="min-h-screen bg-[#050505] flex flex-col">
      <Navbar />
      
      <main className="flex-1 container mx-auto px-4 md:px-8 py-12">
        <h1 className="font-heading text-3xl md:text-4xl text-white mb-2">{t('return_title')}</h1>
        <p className="text-[#A8A29E] mb-8">{t('return_subtitle')}</p>

        <div className="max-w-4xl space-y-8">
          {/* Return Policy */}
          <div className="glass rounded-xl p-6">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-[#D4AF37]/10 rounded-lg">
                <RotateCcw size={24} className="text-[#D4AF37]" />
              </div>
              <div>
                <h2 className="font-heading text-xl text-white mb-2">{t('return_14_days')}</h2>
                <p className="text-[#A8A29E] mb-4">
                  {t('return_14_days_desc')}
                </p>
                <ul className="space-y-2 text-[#A8A29E]">
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-[#D4AF37]"></span>
                    {t('return_unopened')}
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-[#D4AF37]"></span>
                    {t('return_original_packaging')}
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-[#D4AF37]"></span>
                    {t('return_costs_own')}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* How to Return */}
          <div className="glass rounded-xl p-6">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-[#D4AF37]/10 rounded-lg">
                <Package size={24} className="text-[#D4AF37]" />
              </div>
              <div>
                <h2 className="font-heading text-xl text-white mb-2">{t('how_to_return')}</h2>
                <ol className="space-y-3 text-[#A8A29E]">
                  <li className="flex gap-3">
                    <span className="w-6 h-6 rounded-full bg-[#D4AF37] text-black flex items-center justify-center text-sm font-bold flex-shrink-0">1</span>
                    <span>{t('return_step_1')}</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="w-6 h-6 rounded-full bg-[#D4AF37] text-black flex items-center justify-center text-sm font-bold flex-shrink-0">2</span>
                    <span>{t('return_step_2')}</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="w-6 h-6 rounded-full bg-[#D4AF37] text-black flex items-center justify-center text-sm font-bold flex-shrink-0">3</span>
                    <span>{t('return_step_3')}</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="w-6 h-6 rounded-full bg-[#D4AF37] text-black flex items-center justify-center text-sm font-bold flex-shrink-0">4</span>
                    <span>{t('return_step_4')}</span>
                  </li>
                </ol>
              </div>
            </div>
          </div>

          {/* Refund Time */}
          <div className="glass rounded-xl p-6">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-[#D4AF37]/10 rounded-lg">
                <Clock size={24} className="text-[#D4AF37]" />
              </div>
              <div>
                <h2 className="font-heading text-xl text-white mb-2">{t('refund')}</h2>
                <p className="text-[#A8A29E]">
                  {t('refund_desc')}
                </p>
              </div>
            </div>
          </div>

          {/* Exceptions */}
          <div className="glass rounded-xl p-6 border border-red-500/30">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-red-500/10 rounded-lg">
                <AlertCircle size={24} className="text-red-500" />
              </div>
              <div>
                <h2 className="font-heading text-xl text-white mb-2">{t('return_exceptions')}</h2>
                <p className="text-[#A8A29E] mb-4">
                  {t('return_exceptions_desc')}
                </p>
                <ul className="space-y-2 text-[#A8A29E]">
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-red-500"></span>
                    {t('return_exception_opened')}
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-red-500"></span>
                    {t('return_exception_damaged')}
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-red-500"></span>
                    {t('return_exception_giftcards')}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default RuilenRetournerenPage;
